// clickOutside.ts
type ClickOutsideElement = HTMLElement & {
  __clickOutsideHandler__?: (event: MouseEvent) => void
}

export default {
  mounted(el: ClickOutsideElement, binding: any) {
    el.__clickOutsideHandler__ = (event: MouseEvent) => {
      if (!(el === event.target || el.contains(event.target as Node))) {
        binding.value(event)
      }
    }
    document.addEventListener('click', el.__clickOutsideHandler__)
  },
  unmounted(el: ClickOutsideElement) {
    if (el.__clickOutsideHandler__) {
      document.removeEventListener('click', el.__clickOutsideHandler__)
    }
  },
}
